module.exports = __webpack_public_path__ + "static/media/logout-tutorial-1.40b99ea0.gif";